<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>记录查询</el-breadcrumb-item>
            <el-breadcrumb-item>车辆通行记录</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="filters" class="user-search">
            <el-form-item>
                <el-input size="small" v-model="filters.licensePlate" clearable placeholder="请输入车牌号码"
                          @keyup.enter.native="handleSearch"></el-input>
            </el-form-item>
            <el-form-item>
                <el-select size="small" v-model="filters.direction" clearable filterable placeholder="请选择出入方向">
                    <el-option label="出场" value="2"></el-option>
                    <el-option label="入场" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select size="small" v-model="filters.parkingType" clearable filterable placeholder="请选择停车类型">
                    <el-option label="临停" value="1"></el-option>
                    <el-option label="长租" value="2"></el-option>
                    <el-option label="会员" value="3"></el-option>
                    <el-option label="长租过期会员" value="4"></el-option>
                    <el-option label="长租超员" value="5"></el-option>
                    <el-option label="储值" value="6"></el-option>
                    <el-option label="预约" value="7"></el-option>
                    <el-option label="长租过期临停" value="8"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker
                        size="small"
                        v-model="date"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-search" type="primary" size="small" @click="handleSearch">查询</el-button>
                <el-button type="primary" size="small" @click="handleExportExcel">导出</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table
                id="out-table"
                size="small"
                :data="tableData"
                highlight-current-row
                border
                v-loading="loading"
                element-loading-text="拼命加载中"
                style="width: 100%"
                :row-style="{height:'45px'}"
                :cell-style="{padding:'0px'}"
                :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                stripe height="500" max-height="500"
                :default-sort="{prop: 'passTime', order: 'descending'}">
            <el-table-column min-width="30" type="index" label="序号"></el-table-column>
            <el-table-column prop="licensePlate" label="车牌号码" align="center">
                <template slot-scope="scope">
                    <span>{{scope.row.licensePlate?scope.row.licensePlate:'无牌车'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="rfidNo" label="卡号" align="center"></el-table-column>
            <el-table-column prop="direction" label="出入方向" align="center">
                <template slot-scope="scope">
                    <el-tag type="info" v-if="scope.row.direction == 2">出场</el-tag>
                    <el-tag type="danger" v-else-if="scope.row.direction == 1">入场</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="roadName" label="道口名称" align="center"></el-table-column>
            <el-table-column prop="passTime" label="通行时间" align="center"></el-table-column>
            <el-table-column prop="parkingType" label="停车类型" align="center">
                <template slot-scope="scope">
                    <el-tag type="primary" v-if="scope.row.parkingType == 1">临停</el-tag>
                    <el-tag type="success" v-else-if="scope.row.parkingType == 2">长租</el-tag>
                    <el-tag type="warning" v-else-if="scope.row.parkingType == 3">会员</el-tag>
                    <el-tag type="info" v-else-if="scope.row.parkingType == 4 || scope.row.parkingType == 8">长租过期
                    </el-tag>
                    <el-tag type="danger" v-else-if="scope.row.parkingType == 5">长租超员</el-tag>
                    <el-tag type="danger" v-else-if="scope.row.parkingType == 6">储值</el-tag>
                    <el-tag type="danger" v-else-if="scope.row.parkingType == 7">预约</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="passImg" label="通行图片" align="center">
                <template slot-scope="scope">
                    <el-image
                            style="width: 50px; height: 50px"
                            :src="scope.row.passImg?scope.row.passImg:require('../../../assets/images/defaultImg.png')"
                            :preview-src-list="[scope.row.passImg?scope.row.passImg:require('../../../assets/images/defaultImg.png')]">
                        <div slot="error">
                            <el-image :src="require('../../../assets/images/defaultImg.png')">
                            </el-image>
                        </div>
                    </el-image>
                </template>
                <!--        <template slot-scope="scope">-->
                <!--          <span @click="handleEdit(scope.row)" style="color: #2a6496">查看</span>-->
                <!--        </template>-->
            </el-table-column>
        </el-table>
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="filters.current"
                       :page-sizes="[10, 100, 200, 500, 1000]"
                       :page-size="filters.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
        <!--        选择导出文件类型-->
        <el-dialog v-draggable title="文件类型" :visible.sync="selectDialog" width="250px">
            <el-form :model="editForm" ref="editForm" size="small" :rules="rules">
                <el-form-item prop="radio" label-width="50px">
                    <el-radio v-model="editForm.radio" label="xls">xls</el-radio>
                    <el-radio v-model="editForm.radio" label="xlsx">xlsx</el-radio>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="selectDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="onExportExcel('editForm')">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
    import {formatDate} from "@/utils";
    import {passRecordList} from "@/api/record/vehiclelist";

    export default {
        name: "equipment",
        data() {
            return {
                loading: false,
                total: 0,
                tableData: [],
                filters: {
                    current: 1,
                    size: 10,
                    direction: '',
                    licensePlate: '',
                    parkingId: '',
                    parkingType: '',
                    startTime: '',
                    endTime: '',
                },
                date: [],
                selectDialog: false,
                editForm: {
                    radio: "",
                },
                rules: {
                    radio: [
                        {required: true, message: '请选择导出类型', trigger: 'change'}
                    ],
                },
            }
        },
        created() {
            this.fetchData();  //调用接口获取动态数据
        },
        methods: {
            fetchData() { //获取数据
                let that = this;
                that.filters.startTime =
                    that.date && that.date.length
                        ? formatDate(that.date[0], "yyyy-MM-dd")
                        : "";
                that.filters.endTime =
                    that.date && that.date.length
                        ? formatDate(that.date[1], "yyyy-MM-dd")
                        : "";
                let params = {
                    current: that.filters.current,
                    size: that.filters.size,
                    parkingId: that.filters.parkingId,
                    licensePlate: that.filters.licensePlate,
                    parkingType: that.filters.parkingType,
                    direction: that.filters.direction,
                    startTime: that.filters.startTime,
                    endTime: that.filters.endTime,
                };
                that.loading = true;
                passRecordList(params).then((res) => {
                    that.loading = false;
                    that.tableData = res.data.data.records;
                    that.total = res.data.data.total;
                    that.filters.current = res.data.data.current;
                    that.filters.size = res.data.data.size;
                }).catch(error => {
                    that.loading = false;
                    console.log(error);
                });
            },
            handleSizeChange(val) {
                this.filters.size = val;
                this.filters.current = 1;
                this.fetchData();
            },
            handleCurrentChange(val) {
                this.filters.current = val;
                this.fetchData();
            },
            handleSearch() {
                this.filters.current = 1;
                this.fetchData();
            },
            handleExportExcel() {
                this.selectDialog = true;
                this.editForm.radio = "";
            },
            //导出列表
            onExportExcel(editForm) {
                this.$refs[editForm].validate((valid) => {
                    if (valid) {
                        this.$nextTick(function () {
                            if (this.tableData.length === 0) {
                                this.$message.warning("暂无数据可导出");
                                return;
                            }
                            const header = [
                                '序号', '车牌号码', '卡号', '出入方向', '道口名称',
                                '通行时间', '停车类型', '通行图片'
                            ];
                            const dataArray = this.tableData.map((item) => [
                                item.id,
                                item.licensePlate ? item.licensePlate : '无牌车',
                                item.rfidNo,
                                item.direction,
                                item.roadName,
                                item.passTime,
                                item.parkingType == 1 ? '临停' : item.parkingType == 2 ? '长租' :
                                    item.parkingType == 3 ? '会员' : item.parkingType == 4 || item.parkingType == 8 ? '长租过期' :
                                        item.parkingType == 5 ? '长租超员' : item.parkingType == 6 ? '储值' : item.parkingType == 7 ? '预约' : '',
                                item.passImg
                            ]);
                            const worksheet = this.$XLSX.utils.aoa_to_sheet([header, ...dataArray]);

                            const textColumns = ['车牌号码', '卡号', '通行时间'];
                            textColumns.forEach(colName => {
                                const colIndex = header.indexOf(colName);
                                if (colIndex !== -1) {
                                    const range = this.$XLSX.utils.decode_range(worksheet['!ref']);
                                    for (let r = range.s.r; r <= range.e.r; r++) {
                                        const cellAddr = this.$XLSX.utils.encode_cell({r, c: colIndex});
                                        const cell = worksheet[cellAddr];
                                        if (cell) {
                                            cell.t = 's';
                                            cell.z = '@';
                                        }
                                    }
                                }
                            });
                            worksheet['!cols'] = [
                                {wch: 8},
                                {wch: 10},
                                {wch: 18},
                                {wch: 10},
                                {wch: 10},
                                {wch: 20},
                                {wch: 15},
                                {wch: 10}
                            ];
                            const workbook = this.$XLSX.utils.book_new();
                            this.$XLSX.utils.book_append_sheet(workbook, worksheet, '车辆通行记录');
                            const table_write = this.$XLSX.write(workbook, {
                                bookType: this.editForm.radio,
                                bookSST: true,
                                type: "array"
                            });
                            try {
                                this.$FileSaver.saveAs(new Blob([table_write], {type: 'application/octet-stream'}), "车辆通行记录." + this.editForm.radio);
                            } catch (e) {
                                console.log(e, table_write);
                            }
                            this.selectDialog = false;
                            return table_write;
                        });
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .el-table th {
        text-align: center;
    }

    .el-table tbody tr td:first-child {
        text-align: center;
    }

    .user-search {
        margin-top: 20px;
    }

    .el-dialog__wrapper {
        overflow: hidden;
    }
</style>
